import React, { useState } from 'react'

// Custom Imports
import { ButtonV2 } from '../../../atoms/button-v2'
import { Text } from '../../../typography/text'

import { Modal } from '../../../elements/modal'

interface DeleteModalProps {
  cancelButtonText: string
  deleteModalTitle: string
  deleteButtonText: string
  deleteModalDescription: string

  showDeleteModal: boolean
  selectedComment: string | number | null
  handleDelete?: (id: string | number) => Promise<void> | void

  closeDeleteModal: () => void
}

const DeleteModal: React.FC<DeleteModalProps> = (deleteProps) => {
  const {
    cancelButtonText,
    selectedComment,
    deleteButtonText,
    handleDelete,
    deleteModalTitle,
    deleteModalDescription,
    showDeleteModal,
    closeDeleteModal,
  } = deleteProps

  const [buttonLoader, setButtonLoader] = useState<boolean>(false)
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false)

  // Deletes the selected comment.
  const deleteComment = async () => {
    if (handleDelete && selectedComment) {
      setButtonDisabled(true)
      setButtonLoader(true)

      await handleDelete(selectedComment)

      setButtonDisabled(false)
      setButtonLoader(false)

      closeDeleteModal()
    }
  }

  const modalButtons = [
    <ButtonV2
      key={Math.random()}
      variant="secondary"
      label={cancelButtonText}
      handleClick={() => {
        closeDeleteModal()
      }}
      disabled={buttonDisabled}
    />,
    <ButtonV2
      key={Math.random()}
      variant="primary"
      label={deleteButtonText}
      handleClick={async () => await deleteComment()}
      loading={buttonLoader}
      disabled={buttonDisabled}
    />,
  ]

  return (
    <Modal
      isOpen={showDeleteModal}
      title={deleteModalTitle}
      footerArray={modalButtons}
      body={<Text label={deleteModalDescription} type="body" />}
    />
  )
}

export default DeleteModal
